import { OverduePaymentButtonWidgetContent } from './OverduePaymentButtonWidgetContent';
import type { OverduePaymentButtonWidgetProps } from './useOverduePaymentButtonWidget';

export const OverduePaymentButtonWidget = ({ handlers, data, hooks }: OverduePaymentButtonWidgetProps) => {
  return <OverduePaymentButtonWidgetContent data={data} handlers={handlers} hooks={hooks} />;
};
